import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Importing SCSS files
import "./assets/scss/dashlite.scss";
import "./assets/scss/style-email.scss";
import "./App.css"

// Importing the reportWebVitals function
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store/store";

// Suppress the harmless "ResizeObserver loop completed with undelivered
// notifications" warning that surfaces as a fatal error in CRA's dev
// overlay. The warning is benign per the spec (a single missed delivery
// is silently retried on the next frame) and is emitted by many UI
// libraries (echarts, antd, ag-grid, etc.). We filter ONLY this exact
// message so genuine errors continue to propagate.
const RESIZE_OBSERVER_LOOP_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (event) => {
  if (event.message && RESIZE_OBSERVER_LOOP_ERR.test(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (event) => {
  const msg = (event.reason && (event.reason.message || event.reason)) + "";
  if (RESIZE_OBSERVER_LOOP_ERR.test(msg)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

// Using the new ReactDOM client to create and manage the root
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// Optional: Measurement of performance in your app
// You can pass a function to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
